"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeEnum = void 0;
var ThemeEnum;
(function (ThemeEnum) {
    ThemeEnum["Dark"] = "dark";
    ThemeEnum["Light"] = "light";
})(ThemeEnum = exports.ThemeEnum || (exports.ThemeEnum = {}));
//# sourceMappingURL=theme-enum.js.map